import { render, staticRenderFns } from "./ResearchfieldContent.vue?vue&type=template&id=777a877e"
import script from "./ResearchfieldContent.vue?vue&type=script&lang=js"
export * from "./ResearchfieldContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports